<input
  #inputEl
  type="text"
  [class]="inputClass"
  [style]="inputStyle"
  [placeholder]="placeholder"
  (input)="onInput($event)"
  (paste)="onPaste($event)"
  (blur)="onTouched()"
  maxlength="13"
  autocomplete="off">
